export default __webpack_public_path__ + "static/media/ISMO CLASS-10_SYLLABUS_2025-26.4a65f414.pdf";